/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ selectionLimit: NonNullable<unknown> }} Pretty_Key_Eel_SucceedInputs */

const en_pretty_key_eel_succeed = /** @type {(inputs: Pretty_Key_Eel_SucceedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selection limit (${i?.selectionLimit}) reached`)
};

const de_pretty_key_eel_succeed = /** @type {(inputs: Pretty_Key_Eel_SucceedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auswahlgrenze (${i?.selectionLimit}) erreicht`)
};

/**
* | output |
* | --- |
* | "Selection limit ({selectionLimit}) reached" |
*
* @param {Pretty_Key_Eel_SucceedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pretty_key_eel_succeed = /** @type {((inputs: Pretty_Key_Eel_SucceedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pretty_Key_Eel_SucceedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pretty_key_eel_succeed(inputs)
	return de_pretty_key_eel_succeed(inputs)
});